import { Pipe, PipeTransform } from '@angular/core';
import { LocalServiceService } from 'src/app/services/local-service.service';

@Pipe({
  name: 'customPatientLabel',
  standalone: true,
  pure: false
})
export class CustomPatientLabelPipe implements PipeTransform {
  private customLabelMap: { [key: string]: string } = {};

  constructor(private localService: LocalServiceService) {
    this.localService.broadCastPermissions$.subscribe((value) => {
      const focusBrandConfiguration = value?.focusBrandConfiguration || [];
      if (focusBrandConfiguration?.customLabelsConfig) {
        this.customLabelMap = {};
        for (const label of focusBrandConfiguration.customLabelsConfig) {
          const key = label.labelName.replace(/\s+/g, '').toLowerCase();
          this.customLabelMap[key] = label.configuredValue;
        }
      }
    });
  }

  transform(value: string): string {
    if (!value) return value;
    const normalized = value.replace(/\s+/g, '').toLowerCase();
    if (normalized === 'patientid' && this.customLabelMap['patientid']) {
      return this.customLabelMap['patientid'];
    }
    if (this.customLabelMap['patient']) {
      const singular = this.customLabelMap['patient'];
      const regexPlural = /\bpatients\b/gi;
      const regexSingular = /\bpatient\b/gi;
      let result = value;
      if (regexPlural.test(result)) {
        result = result.replace(regexPlural, singular + 's');
      }
      if (regexSingular.test(result)) {
        result = result.replace(regexSingular, singular);
      }

      return result;
    }

    return value;
  }
}